import { useState } from "react";

interface SearchFilterBarProps {
  searchQuery: string;
  onSearchChange: (value: string) => void;
  selectedInsurer: string;
  onInsurerChange: (value: string) => void;
  insurers: string[];
  totalPlans: number;
  filteredCount: number;
}

export default function SearchFilterBar({
  searchQuery,
  onSearchChange,
  selectedInsurer,
  onInsurerChange,
  insurers,
  totalPlans,
  filteredCount,
}: SearchFilterBarProps) {
  const [isFocused, setIsFocused] = useState(false);

  return (
    <div className="bg-white rounded-2xl border border-slate-100 p-4 md:p-5 shadow-sm">
      <div className="flex flex-col md:flex-row gap-3 md:gap-4 items-stretch md:items-center">
        {/* Search Input */}
        <div className="relative flex-1 min-w-0">
          <div
            className={`flex items-center gap-3 px-4 py-2.5 rounded-xl border transition-all duration-200 ${
              isFocused
                ? "border-primary-400 ring-2 ring-primary-100 bg-white"
                : "border-slate-200 bg-slate-50 hover:bg-white"
            }`}
          >
            <i className="ri-search-line text-slate-400 text-lg"></i>
            <input
              type="text"
              value={searchQuery}
              onChange={(e) => onSearchChange(e.target.value)}
              onFocus={() => setIsFocused(true)}
              onBlur={() => setIsFocused(false)}
              placeholder="Search by company or plan name..."
              className="flex-1 bg-transparent text-sm text-slate-800 placeholder:text-slate-400 outline-none min-w-0"
            />
            {searchQuery && (
              <button
                onClick={() => onSearchChange("")}
                className="text-slate-400 hover:text-slate-600 transition-colors cursor-pointer"
              >
                <i className="ri-close-circle-line text-lg"></i>
              </button>
            )}
          </div>
        </div>

        {/* Filter Dropdown */}
        <div className="relative shrink-0">
          <div className="flex items-center gap-2 px-4 py-2.5 rounded-xl border border-slate-200 bg-slate-50 hover:bg-white transition-colors">
            <i className="ri-filter-3-line text-slate-400 text-lg"></i>
            <select
              value={selectedInsurer}
              onChange={(e) => onInsurerChange(e.target.value)}
              className="bg-transparent text-sm text-slate-700 outline-none cursor-pointer min-w-[160px]"
            >
              <option value="">All Insurers</option>
              {insurers.map((insurer) => (
                <option key={insurer} value={insurer}>
                  {insurer}
                </option>
              ))}
            </select>
          </div>
        </div>

        {/* Results Count */}
        <div className="shrink-0 text-sm text-slate-500 md:text-right">
          Showing <span className="font-semibold text-slate-700">{filteredCount}</span>{" "}
          of <span className="font-semibold text-slate-700">{totalPlans}</span> plans
        </div>
      </div>
    </div>
  );
}